import { combineReducers, configureStore, Middleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { libraryApi } from 'api/libraryApi';
import { rtkQueryErrorHandler } from './middleware/rtkQueryErrorHandler';

const rootReducer = combineReducers({
  [libraryApi.reducerPath]: libraryApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      libraryApi.middleware as Middleware,
      rtkQueryErrorHandler,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        libraryApi.middleware as Middleware,
        rtkQueryErrorHandler,
      ),
    preloadedState,
  });
};
export type AppStore = ReturnType<typeof setupStore>;
